import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ITagCatalogRepository } from '../../domain/repositories/tag-catalog.repository';
import { Tag } from '../../domain/models/tag.model';
import { TagCatalogRemoteDatasource } from '../datasources/remote/tag-catalog.remote-datasource';
import { TagMapper } from '../mappers/tag.mapper';

@Injectable()
export class TagCatalogRepositoryImpl implements ITagCatalogRepository {
  private readonly datasource = inject(TagCatalogRemoteDatasource);
  private readonly mapper = inject(TagMapper);

  public getTags(): Observable<readonly Tag[]> {
    return this.datasource.getTags().pipe(map((dtos) => dtos.map((dto) => this.mapper.toTag(dto))));
  }
}
